module.exports = __webpack_public_path__ + "static/img/2007.bee2e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2007.jpg
// module id = 298
// module chunks = 0